import { gsap } from "gsap";
import faqData from "./data/faq.json";
// import headerVideo from '../assets/videos/header.mp4';
// import lunettesIcons from "./data/lunettes_icons.json";
import lunettesIcons from "./data/LunettesIcons.js";
import GradientHeader from "./GradientHeader.js";
import TiltEffect from "./TiltEffect.js";
import TitleAnimator from "./TitleAnimator.js";
import H2Animator from "./H2Animator.js";
// import ImageTrail from "./ImageTrail.js";
import Marquee from "./Marquee.js";
import Faq from "./Faq.js";
import ContactForm from './ContactForm.js';
import RandomMiniIcons from "./RandomMiniIcons.js";
import MobileOverlayMenu from './MobileOverlayMenu.js';
import GallerySlider from './GallerySlider.js';
import Lightbox from './Lightbox.js';

// console.log('galleryImages:', galleryImages);



document.addEventListener("DOMContentLoaded", () => {
  const faq = new Faq("faq-container", faqData);
  faq.init();


// const video = document.querySelector('video source');
// video.src = headerVideo;


  new MobileOverlayMenu();

  const styles = getComputedStyle(document.documentElement);
  const getColor = (name) => styles.getPropertyValue(name).trim();

  const colorSets = [
    ["--colorBlueDark", "--colorBordeaux", "--colorBlue"].map(getColor),
    ["--colorBrown", "--colorOrangeSoft", "--colorBeigeLight"].map(getColor),
    ["--colorOrangeSoft", "--colorBlue", "--colorBrown"].map(getColor),
    ["--colorBordeaux", "--colorBeigeLight", "--colorOrangeSoft"].map(getColor),
    ["--colorBlue", "--colorOrangeSoft", "--colorBordeaux"].map(getColor),
  ];

  new GradientHeader("#header", colorSets);
  new TiltEffect("#header", {
    maxTilt: 3, // angle maximum de l'inclinaison
    // perspective: 800, // distance de perspective
    // scale: 1.5, // échelle lors de l'inclinaison
    // speed: 1000, // vitesse de l'animation
  });
  new TitleAnimator(".animated-title");
  new H2Animator("h2");
  // new ImageTrail(".content", {
  //   size: 220,
  //   threshold: 150,
  // });
  new Marquee(
    ".marquee-section",
    [
      "Des lunettes à votre image",
      "Une conception sur-mesure et artisanale",
      "Une infinité de styles et de couleurs",
      "Une finition à la main, précise et méticuleuse",
      "Des montures uniques et personnalisées",
    ],
    {
      separator: {
        className: "my-custom-sep", // create .my-custom-sep in your SCSS
        type: "line", // optional
        spacing: "2rem",
      },
    },
  );


new ContactForm({
    formSelector: '#contact-form',
    successSelector: '.form-success',
    // endpoint: 'https://formsubmit.co/ajax/design@garysandoz.ch'
    endpoint: 'https://formsubmit.co/ajax/contact@lalunette.ch'
  });

  // new RandomMiniIcons(".step-image", lunettesIcons);
  

new GallerySlider({ container: '[data-gallery]', visibleSlides: 3 });
new Lightbox();



  //   const smoother = new SmoothScroll({
  //     smooth: 2.0,        // bigger = stronger inertia (interpreted by fallback)
  //     effects: true,
  //     normalizeScroll: true,
  //     smoothTouch: 0.4,
  //     breakpoint: 5000       // 0 = always enabled, or use 768 to enable only >=768px
  //   });

  // new ScrollLetters('#scroll-animations');
  // GSAP Timeline pour révélation SVG

  const tl = gsap.timeline();
  tl.fromTo(
    "#header svg",
    {
      opacity: 0,
      filter: "blur(70px)",
      scale: 1.1,
    }, // état initial
    {
      opacity: 1,
      filter: "blur(0px)",
      scale: 1,
      duration: 2.2,
      ease: "power2.out",
    },
  );
});
